export const HowItWorksMocks = {
  title: 'How It Works?',
  description:
    '<ul><li>Pain happens when your receptors send a signal from your spine to your brain. Cold sensations, like menthol, stimulate receptors to block those signals to relieve pain.<sup>1,2</sup></li><li>The fast acting, menthol based formula of Biofreeze provides you targeted pain relief when directly applied to the skin.</li></ul>',
  linkText: 'See all products',
  link: '/products/',
  image: {
    mobile: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/blt27bc8011fe9b648a/6888aa3b105461deb94d8859/How_it_works_mob.png',
      alt: 'Banner text beside an illustration of a human brain with a pain signal icon on green background.',
    },
    desktop: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/bltac39ed0b8a663328/6888aa360e6c3281ef2e99c2/How_it_works_des.png',
      alt: 'Banner text beside an illustration of a human brain with a pain signal icon on green background.',
    },
  },
  imageTextTop:
    '<p><span>Pain signals</span> become<br/>blocked before reaching<br/>the brains</p>',
  imageTextBottom:
    '<p>Biofreeze produces<br/><span>a cold sensation</span><br/>overriding the pain signals</p>',
  imageNote:
    '1. Melzack, R, Wall, P. Pain Mechanisms: A New Theory. Science, Vol. 150, 1965, 971-979.<br/>2. Page, P, Alexander, L. The clinical effectiveness of Biofreeze topical analgesic on musculoskeletal pain: a systemic review. J Perform Health Res. 2017, 1:1-10.',
};

export const HowItWorksOthersMocks = {
  ...HowItWorksMocks,
  linkText: 'Learn more',
  link: '/how-it-works/',
};

export const HowItWorksProductsMocks = {
  ...HowItWorksOthersMocks,
  description:
      '<ul><li>Pain happens when your receptors send a signal from your spine to your brain. Cold sensations, like menthol, stimulate receptors to block those signals to relieve pain.<sup>1,2</sup></li><li>The fast acting cooling, menthol based formula of Biofreeze provides you targeted pain relief when directly applied to the skin.</li></ul>',
};

export const HowItWorksFRMocks = {
  ...HowItWorksMocks,
  image: {
    mobile: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/blt27bc8011fe9b648a/6888aa3b105461deb94d8859/How_it_works_mob.png',
      alt: 'Texte de la bannière à côté de l’illustration d’un cerveau avec une icône de signal de douleur sur fond vert.',
    },
    desktop: {
      src: 'https://eu-images.contentstack.com/v3/assets/bltcec956bfb728201c/bltac39ed0b8a663328/6888aa360e6c3281ef2e99c2/How_it_works_des.png',
      alt: 'Texte de la bannière à côté de l’illustration d’un cerveau avec une icône de signal de douleur sur fond vert.',
    },
  },
  title: 'Comment ça fonctionne?',
  description:'<ul><li>La douleur se produit lorsque les récepteurs envoient un message de la colonne au cerveau. Les sensations froides, comme celle du menthol, stimulent les récepteurs pour bloquer ces signaux et soulager la douleur<sup>1,2</sup>.</li><li>La formule à action rapide à base de menthol de Biofreeze procure un soulagement ciblé de la douleur lorsqu’on l’applique directement sur la peau.</li></ul>',
  linkText: 'Voir tous les produits',
  link: '/fr/products/',
  imageTextTop:
      '<p><span>LES SIGNAUX DE LA DOULEUR</span><br/>SONT BLOQUÉS AVANT DE<br/>PARVENIR AU CERVEAU</p>',
  imageTextBottom:
      '<p>BIOFREEZE PRODUIT UNE<br/><span>SENSATION DE FROID</span> QUI<br/>COURT-CIRCUITE LES SIGNAUX<br/>DE LA DOULEUR</p>',
}
export const HowItWorksOthersFRMocks = {
  ...HowItWorksFRMocks,
  linkText: 'En savoir plus',
  link: '/fr/how-it-works/',
}